import { render, staticRenderFns } from "./BodyComponent.vue?vue&type=template&id=2a38beaf&scoped=true&"
import script from "./BodyComponent.vue?vue&type=script&lang=js&"
export * from "./BodyComponent.vue?vue&type=script&lang=js&"
import style0 from "./BodyComponent.vue?vue&type=style&index=0&id=2a38beaf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38beaf",
  null
  
)

export default component.exports